import styles from "./testCaseResult.module.scss";
import {
  ResultEnum,
  TransformExecuteResponse
} from "../../../types/clientTypes";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

type TestCaseResultProps = {
  executeResponse: TransformExecuteResponse;
}

export const TestCaseResult = ({ executeResponse }: TestCaseResultProps) => {
  const { t } = useTranslation();

  const resultStyle = useMemo((): string => {
    let result = styles.container;
    switch (executeResponse.result) {
      case ResultEnum.passed:
        result += ` ${styles.passed}`;
        break;
      case ResultEnum.failed:
      case ResultEnum.serverError:
        result += ` ${styles.failed}`;
        break;
      case ResultEnum.passedExecutionTime:
        result += ` ${styles.passedExecution}`;
        break;
      case ResultEnum.skipped:
        result += ` ${styles.skipped}`;
        break;
    }

    return result;
  }, [executeResponse])

  const result = useMemo((): string => {
    switch (executeResponse.result) {
      case ResultEnum.passed:
        return t("common.passed");
      case ResultEnum.failed:
        return t("common.failed");
      case ResultEnum.passedExecutionTime:
        return t("common.passedExecutionTime");
      case ResultEnum.serverError:
        return t("common.serverError");
      case ResultEnum.skipped:
        return t("common.skipped");
      default:
        return "";
    }
  }, [executeResponse, t])

  return (
    <div className={resultStyle}>
      {result}
    </div>
  );
}